var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"back-to-top hide-desktop"},[_c('btn',{attrs:{"aria-label":"back to top","size":"small","circle":""},on:{"click":_vm.backToTop}},[_c('div',{staticClass:"icon-arrow-up"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }